import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-market-information',
  templateUrl: './market-information.component.html',
  styleUrls: ['./market-information.component.scss']
})
export class MarketInformationComponent implements OnInit {
  feedbackForm: FormGroup = new FormGroup({
    email: new FormControl(),
    mobile: new FormControl(),
    message: new FormControl(),
  })

  constructor(private http: HttpClient) { }
  submitFeedback() {
    let { value: feedbackForm } = this.feedbackForm;
    this.http.post(`mail_helper.php`, feedbackForm).subscribe(data => {

    }, err => {

      // console.log("errrrrrrrrrrrrr",err);
    })
    this.feedbackForm.reset();

  }

  ngOnInit() {
  }

}
